<div fxLayout="column" fxFLex>
  <div fxLayout="column" fxFill>
    <form [formGroup]="" enctype="multipart/form-data">
      <section>
        <div fxLayout="column">
          <div
            class="content"
            fxLayout="row"
            fxFlex="100"
            fxFlex.xs="100"
            fxFlex.md="100"
          >
            <div class="image">
              <div class="image__preview">
                <div class="image__preview--img">
                  <img
                    [src]="user?.detailperson?.photo"
                    [alt]=""
                    onerror="javascript:this.src='/assets/images/avatars/default-user.jpg'"
                  />
                </div>
                <div
                  *ngIf="showEditButton"
                  class="image__preview--label preview--label"
                >
                  <button
                    type="button"
                    mat-fab
                    *ngIf="!loading"
                    (click)="openModal()"
                  >
                    <img
                      class="preview--label__icon"
                      src="/assets/icons/custom/add_photo.svg"
                      alt="upload image profile"
                    />
                  </button>
                  <button type="button" mat-fab *ngIf="loading">
                    <mat-spinner
                      class="preview--label__spinner"
                      diameter="20"
                    ></mat-spinner>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="information" fxLayout="row" fxLayoutAlign="center center">
            <div
              class="information__name"
              matTooltip="{{ user?.detailperson?.name | titlecase }}"
            >
              <span class="label"
                >{{ user?.detailperson?.name | titlecase }}
                {{ user?.detailperson?.last_name | titlecase }}</span
              >
            </div>
          </div>
        </div>
      </section>
    </form>
  </div>
</div>
